<template>
	<button
		type="button"
		class="flex items-center gap-3 rounded-full bg-secondary px-5 py-[11px] shadow-[0px_1px_3px_1px_rgba(0,0,0,0.15)] transition-all duration-300 hover:shadow-lg"
		@click="$event => emit('click', $event)"
	>
		<slot name="content">
			<IconMaterialSymbolsArrowDownward class="size-5 text-black" />
			<span class="text-base font-medium text-black">{{ text }}</span>
		</slot>
	</button>
</template>
<script lang="ts" setup>
interface Props {
	text?: string;
}

const props = withDefaults(defineProps<Props>(), {
	text: 'Imóveis similares'
});

const emit = defineEmits<{
	click: [MouseEvent];
}>();
</script>
